module.exports = __webpack_public_path__ + "img/Qualidade.cb83eb50.jpg";